import { Outlet } from 'react-router-dom';

export default function LoyalPassAdminLayout() {
    return <Outlet />;
}
